var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from 'styled-components';
import { FONTS, SIZES, Typography } from '@fupa/fupa-uikit';
import React from 'react';
const TitleWrapper = styled.div.withConfig({
  componentId: "sc-1udjlfv-0"
})(["box-sizing:border-box;display:flex;padding:", " ", " ", ";min-height:", ";", ""], SIZES['16'], SIZES['16'], SIZES['24'], SIZES[112], props => props.theme.streamLayoutOneColBig(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-height: 6.25rem;\n  "]))));
const StyledTypography = styled(Typography).withConfig({
  componentId: "sc-1udjlfv-1"
})(["&&&{line-height:1.5;", "}"], props => props.theme.streamLayoutOneColBig(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      font-size: ", ";\n    "])), FONTS[24]));
export default function ActivityTitle(_ref) {
  let {
    title
  } = _ref;
  return /*#__PURE__*/React.createElement(TitleWrapper, {
    "data-sentry-element": "TitleWrapper",
    "data-sentry-component": "ActivityTitle",
    "data-sentry-source-file": "ActivityTitle.tsx"
  }, /*#__PURE__*/React.createElement(StyledTypography, {
    variant: "title2",
    "data-sentry-element": "StyledTypography",
    "data-sentry-source-file": "ActivityTitle.tsx"
  }, title));
}